import { FolioScrapperRequest } from "./FolioRequest";

export class AnularFolios extends FolioScrapperRequest {
   desde: number;
   hasta: number;
   motivoAnulacion: string;
   timbrajeId: string;
}
